
import { Component, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";
import "@/store/modules/forms/form9";
const form9State = namespace("Form9");

import Form9ProcessHeader from "@/components/process/Form9/components/Form9ProcessHeader.vue";
import Spinner from "@/components/utils/Spinner.vue";
import { form9DataInfoType, form9StatusInfoType } from '@/types/Information/Form9';
import { packageInfoType } from '@/types/Information';

import { GetForm9PdfType } from "./components/Form9PdfType";

@Component({
    components:{
        Form9ProcessHeader,
        Spinner
    }
})
export default class SubmitForm9 extends Vue {

    @form9State.State
    public currentRequisitionId: string;

    @form9State.State
    public form9Info: form9DataInfoType;

    stepsCompleted = {} as form9StatusInfoType;  
    mountedData = false; 
    packageInfo = {} as packageInfoType;
    submitting = false;
    errorMsg=""

    mounted() {
        this.mountedData = false;    
        this.submitting = false;    
        this.errorMsg = ""
        this.stepsCompleted = {
            first: true,
            second: true,
            third: false
        }
        this.mountedData = true;         
    }  

    public submit() {

        this.submitting = true;
        this.errorMsg =""

        const url = "/form9/efiling/"+this.currentRequisitionId+"/submit/";

        const header = {
            responseType: "json",
            headers: {
                "Content-Type": "application/json",
            }
        }

        const body = {
            document_type: GetForm9PdfType(this.form9Info) //"REQ"
        }

        this.$http.post(url, body, header)
        .then(res => {                            
            // this.submitting = false;
            if(res.data?.message=="success" && res.data?.redirectUrl){
                const eFilingUrl = res.data?.redirectUrl
                location.replace(eFilingUrl);
            }else
                this.submitting = false;
        }, err => {
            console.log(err.response?.data?.message);
            const generalError = " Error in submission. Please refresh the page and try again."
            if(err.response?.data?.message)
                this.errorMsg = err.response.data.message
            else if(err.response?.data?.detail)
                this.errorMsg = err.response.data.detail+generalError
            else
                this.errorMsg = generalError
            this.submitting = false;
        });        
    }

    public cancel() {
        this.$router.push({name: "dashboard" }) 
    }
}
